/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useEffect, useRef, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import InnerPillar from './InnerPillar';
import { DetailsContext } from '../../context/detailsContext';
import CountUp from 'react-countup';
import { durations, delays, easings, colors } from '../../constants';
import { CarouselContext } from '../../context/carouselContext';
import { mq, mqH, mqLandscape } from '../../utils/mediaQuery';
// import { useBreakpoint } from '../../context/breakpoint';
import {
  pillarContainer,
  pillarSide,
  nonScaled,
  // scaled,
  // reveal,
  singlePillarContainer,
} from './styling';
// import {
//   getPositionFromTop,
//   getPositionFromLeft,
//   getPillarPositionLeft,
// } from '../../utils/elementProperties';

const Pillar = ({
  color,
  totalPercent,
  shownPercent,
  // bottomPercent,
  // topPercent,
  hasScaledPillar,
  scaleSizeX,
  scaleSizeY,
  current,
  // sceneRef,
  // topLeftRef,
  // bottomLeftRef,
  // pillarHeightInPixel,
  // origWidthOfPillar,
  // scaledWidthPixelSize,
  blurValue,
  showPillarGradient,
  pillarPosition,
  backgroundPillar,
  isVisible,
  // currentSwiperTranslate,
}) => {
  // const breakpoints = useBreakpoint();

  const {
    fadeOutDetails,
    viewDetails,
    showRestOfPillars,
    setShowRestOfPillars,
  } = useContext(DetailsContext);
  const {
    // isRotating,
    revealAnimationDone,
    setRevealAnimationDone,
  } = useContext(CarouselContext);

  const [animateReveal, setAnimateReveal] = useState(false);
  const [showFullPillar, setShowFullPillar] = useState(true);
  // const [animateOutPercentCounter, setAnimateOutPercentCounter] = useState(
  //   current ? false : true,
  // );

  // const [
  //   scaledPillarTranslateValues,
  //   setScaledPillarTranslateValues,
  // ] = useState({ yTop: 0, yBottom: 0, xLeft: 0, xRight: 0 });

  // let topPillarRef = useRef();
  // let bottomPillarRef = useRef();
  let countRef = useRef();

  const props = {};

  if (!hasScaledPillar) {
    props.css = {
      ...pillarContainer,
      ...singlePillarContainer(backgroundPillar),
    };

    props.style = {
      transform: backgroundPillar
        ? 'none'
        : `translateY(${showRestOfPillars ? '0' : '10px'})`,
      opacity: backgroundPillar ? 1 : showRestOfPillars ? 1 : 0,
    };

    if (backgroundPillar) {
      props.style['filter'] = `blur(${blurValue}px)`;
    }
  } else {
    props.css = {
      ...pillarContainer,
      ...{
        height: 300,
        [`${mqLandscape}`]: {
          height: 200,
          width: '36px',
        },
        [`${mq('sm')} and ${mqH('xs')}`]: {
          height: 200,
          width: '36px',
        },
        [mq('md')]: {
          width: '36px',
        },
      },
      transition: `transform ${
        fadeOutDetails ? 0 : durations.scalePillarDuration
      }ms ${easings.viewDetailsOpacity}, opacity ${
        fadeOutDetails ? 0 : durations.scalePillarDuration
      }ms ${easings.pillarTranslate}`,
    };

    props.style = {
      filter: `blur(${blurValue}px)`,
      transform: `scaleX(${
        revealAnimationDone && viewDetails && current ? scaleSizeX : 1
      }) scaleY(${
        revealAnimationDone && viewDetails && current ? scaleSizeY : 1
      })`,
    };
  }

  // useEffect(() => {
  //   if (!current) {
  //     // console.log('Pillar useEffect1');
  //     setAnimateOutPercentCounter(true);
  //   }
  // }, [isRotating, current]);

  useEffect(() => {
    if (!animateReveal) {
      // console.log('Pillar useEffect2');
      setTimeout(() => {
        setAnimateReveal(true);
        setTimeout(() => {
          setRevealAnimationDone(true);
        }, durations.revealPillarDuration);
      }, delays.revealAnimation);
    }
  }, [animateReveal, setRevealAnimationDone]);

  // useEffect(() => {
  //   if (viewDetails && current && !backgroundPillar && isVisible) {
  //     // console.log('Pillar if useEffect3');
  //     setAnimateOutPercentCounter(true);
  //   } else if (!viewDetails && current) {
  //     // console.log('Pillar else useEffect3');
  //     setTimeout(() => {
  //       setAnimateOutPercentCounter(false);
  //     }, durations.scalePillarDuration);
  //   }
  // }, [viewDetails, current, backgroundPillar, isVisible]);

  useEffect(() => {
    if (viewDetails && hasScaledPillar && current && isVisible) {
      // console.log('Pillar if useEffect4');
      setShowFullPillar(false);
      setTimeout(() => {
        setShowRestOfPillars(true);
      }, durations.scalePillarDuration / 4);
    } else if (
      !viewDetails &&
      hasScaledPillar &&
      current &&
      showRestOfPillars
    ) {
      // console.log('Pillar else if useEffect4');
      setShowRestOfPillars(false);
      setTimeout(() => {
        setShowFullPillar(true);
      }, durations.scalePillarDuration);
    }
  }, [
    viewDetails,
    current,
    hasScaledPillar,
    setShowRestOfPillars,
    showRestOfPillars,
    isVisible,
  ]);

  // useEffect(() => {
  //   if (hasScaledPillar && viewDetails && current && isVisible) {
  //     // console.log('Pillar if useEffect5');
  //     const scaledPillarPositionLeft =
  //       getPillarPositionLeft(topPillarRef.current) -
  //       Math.abs(currentSwiperTranslate);
  //     console.log('currentSwiperTranslate', currentSwiperTranslate);
  //     console.log('scaledPillarPositionLeft', scaledPillarPositionLeft);

  //     const topLeftPositionFromTop = getPositionFromTop(topLeftRef.current);
  //     const bottomLeftPositionFromTop = getPositionFromTop(
  //       bottomLeftRef.current,
  //     );

  //     const marginBetweenSmallPillars =
  //       breakpoints.sm || breakpoints.ls ? 70 : 40;

  //     const scaleWidthDifference =
  //       (origWidthOfPillar - scaledWidthPixelSize) / 2;

  //     const leftPillarPosition = getPositionFromLeft(topLeftRef.current);

  //     const leftSecondPillarPosition =
  //       getPositionFromLeft(topLeftRef.current) +
  //       marginBetweenSmallPillars +
  //       scaledWidthPixelSize;

  //     const parent = sceneRef.current;
  //     const scalePercentX = scaleSizeX * 100;
  //     const scalePercentY = scaleSizeY * 100;
  //     const topPillarHeight = topPillarRef.current.clientHeight;
  //     const bottomPillarHeight = bottomPillarRef.current.clientHeight;

  //     const topPillarOffsetTop = topPillarRef.current.offsetTop;

  //     const bottomPillarOffsetTop = bottomPillarRef.current.offsetTop;

  //     const pillarParentHeight = parent.clientHeight;

  //     const pillarParentOffsetTop = parent.offsetTop;

  //     const scaledTopPillarOffsetTop =
  //       (scalePercentY / 100) * topPillarOffsetTop;

  //     const scaledBottomPillarOffset =
  //       (scalePercentY / 100) * bottomPillarOffsetTop;

  //     const scaledPillarParentOffsetTop =
  //       (pillarParentHeight - (scalePercentY / 100) * pillarParentHeight) / 2 +
  //       pillarParentOffsetTop;

  //     const totalScaledOffsetTopPillar =
  //       scaledTopPillarOffsetTop + scaledPillarParentOffsetTop;

  //     const totalScaledOffsetBottomPillar =
  //       scaledBottomPillarOffset + scaledPillarParentOffsetTop;

  //     const totalTopPillarDifference =
  //       totalScaledOffsetTopPillar - topLeftPositionFromTop;

  //     const totalBottomPillarDifference =
  //       totalScaledOffsetBottomPillar - bottomLeftPositionFromTop;

  //     const totalGreenPillarLeftDifference =
  //       leftPillarPosition - (scaledPillarPositionLeft + scaleWidthDifference);

  //     const totalBluePillarLeftDifference =
  //       leftSecondPillarPosition -
  //       (scaledPillarPositionLeft + scaleWidthDifference);

  //     const scaledTopPillarTranslateValue = -Math.floor(
  //       (totalTopPillarDifference / scalePercentY) * 100 + topPillarHeight,
  //     );

  //     const scaledBottomPillarTranslateValue = -Math.floor(
  //       (totalBottomPillarDifference / scalePercentY) * 100 +
  //         bottomPillarHeight,
  //     );

  //     const scaledGreenPillarTranslateValueX = Math.floor(
  //       (totalGreenPillarLeftDifference / scalePercentX) * 100,
  //     );

  //     const scaledBluePillarTranslateValueX = Math.floor(
  //       (totalBluePillarLeftDifference / scalePercentX) * 100,
  //     );

  //     setScaledPillarTranslateValues({
  //       yTop: scaledTopPillarTranslateValue,
  //       yBottom: scaledBottomPillarTranslateValue,
  //       xLeft: scaledGreenPillarTranslateValueX,
  //       xRight: scaledBluePillarTranslateValueX,
  //     });
  //   } else {
  //     return;
  //   }
  // }, [
  //   hasScaledPillar,
  //   scaleSizeX,
  //   scaleSizeY,
  //   current,
  //   sceneRef,
  //   topLeftRef,
  //   bottomLeftRef,
  //   viewDetails,
  //   breakpoints.sm,
  //   breakpoints.ls,
  //   origWidthOfPillar,
  //   scaledWidthPixelSize,
  //   color,
  //   currentSwiperTranslate,
  //   isVisible,
  // ]);

  let leftSideStyling = 'left';
  // if (!hasScaledPillar) {
  //   if (pillarPosition === 'top') {
  //     leftSideStyling = 'topLeft';
  //   }
  //   if (pillarPosition === 'bottom') {
  //     leftSideStyling = 'bottomLeft';
  //   }
  // }

  let rightSideStyling = 'right';
  // if (!hasScaledPillar) {
  //   if (pillarPosition === 'top') {
  //     rightSideStyling = 'topRight';
  //   }
  //   if (pillarPosition === 'bottom') {
  //     rightSideStyling = 'bottomRight';
  //   }
  // }

  let pillarHeight = `${totalPercent}px`;

  // if (!hasScaledPillar && !backgroundPillar) {
  //   pillarHeight = `${totalPercent}px`;
  //   if (breakpoints.ls || breakpoints.sm) {
  //     pillarHeight = `${Math.round((totalPercent * 80) / 100)}px`;
  //   }
  //   if (breakpoints.lg) {
  //     pillarHeight = `${totalPercent}px`;
  //   }
  // } else {
  //   pillarHeight = `${totalPercent}%`;
  // }

  return (
    <div {...props}>
      {!hasScaledPillar && !backgroundPillar && (
        <span
          css={{
            fontSize: '20px',
            marginBottom: '5px',
            color: colors.white,
            position: 'relative',
            width: '100%',
            textAlign: 'center',
            [`${mqLandscape}`]: {
              fontSize: '12px',
            },
            [mq('sm')]: {
              fontSize: '14px',
            },
            [mq('md')]: {
              fontSize: '20px',
            },
          }}>
          {shownPercent ? shownPercent : totalPercent}
          <span
            css={{
              fontSize: '14px',
              fontWeight: '300',
              marginLeft: 2,
              verticalAlign: 'text-top',
              [mq('sm')]: {
                fontSize: '14px',
              },
            }}>
            %
          </span>
        </span>
      )}
      <InnerPillar
        styling={[
          css`
            height: ${pillarHeight};
          `,
          nonScaled(color, hasScaledPillar, showPillarGradient, pillarPosition),
        ]}
        scaledVersionStyling={{
          opacity: showFullPillar ? 1 : 0,
        }}
        sideStylingLeft={pillarSide(
          leftSideStyling,
          color,
          hasScaledPillar,
          showPillarGradient,
        )}
        sideStylingRight={pillarSide(
          rightSideStyling,
          color,
          hasScaledPillar,
          showPillarGradient,
        )}
      />

      {hasScaledPillar && (
        <>
          <span
            css={{
              fontSize: '20px',
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              color: colors.white,
              opacity: viewDetails ? 0 : 1,
              transform: `translateY(calc(-${Math.floor(
                totalPercent,
              )}px - 5px))`,
              // willChange: 'transform, opacity',
              // transition: `transform ${durations.revealPillarDuration - 50}ms ${
              //   easings.pillarReveal
              // }, opacity ${
              //   viewDetails ? 100 : durations.viewDetailsDuration
              // }ms ${easings.viewDetailsOpacity}`,
              zIndex: 3,
              [`${mqLandscape}`]: {
                fontSize: '14px',
              },
              [mq('sm')]: {
                fontSize: '14px',
              },
              [mq('lg')]: {
                fontSize: '20px',
              },
            }}
            // style={
            //   animateReveal
            //     ? {
            //         transform: `translateY(calc(-${Math.floor(
            //           totalPercent,
            //         )}px - 5px))`,
            //       }
            //     : {}
            // }
          >
            <CountUp
              ref={countRef}
              // duration={2}
              // start={0}
              duration={0}
              start={shownPercent ? shownPercent : totalPercent}
              end={shownPercent ? shownPercent : totalPercent}
              delay={0.2}
              useEasing={false}
              redraw={false}
            />
            <span
              css={{
                fontSize: '14px',
                fontWeight: '300',
                position: 'absolute',
                marginLeft: 4,
                [`${mqLandscape}`]: {
                  fontSize: '12px',
                  marginLeft: 2,
                },
                [mq('sm')]: {
                  fontSize: '12px',
                  marginLeft: 2,
                },
                [mq('lg')]: {
                  fontSize: '14px',
                  marginTop: 2,
                },
              }}>
              %
            </span>
          </span>
          {/* <InnerPillar
            styling={[
              // `height: ${topPercent}%; bottom: ${bottomPercent}%;`,
              // `height: ${topPercent}%; bottom: 0`,
              scaled('top', color),
              {
                transition: `transform ${
                  fadeOutDetails ? 0 : durations.scalePillarDuration
                }ms ${easings.viewDetailsOpacity}`,
              },
              `opacity: 0`,
            ]}
            scaledVersionStyling={
              scaledPillarTranslateValues.yTop && viewDetails && current
                ? {
                    transform: `translateY(${
                      scaledPillarTranslateValues.yTop
                    }px) translateX(${
                      color === 'green'
                        ? `${scaledPillarTranslateValues.xLeft}px`
                        : `${scaledPillarTranslateValues.xRight}px`
                    })`,
                    opacity: 1,
                  }
                : {}
            }
            sideStylingLeft={pillarSide('topLeft', color)}
            sideStylingRight={pillarSide('topRight', color)}
            ref={topPillarRef}
          />

          <InnerPillar
            styling={[
              // `height: ${bottomPercent}%;`,
              scaled('bottom', color),
              `opacity: 0`,
              {
                transition: `transform ${
                  fadeOutDetails ? 0 : durations.scalePillarDuration
                }ms ${easings.viewDetailsOpacity}`,
              },
            ]}
            scaledVersionStyling={
              scaledPillarTranslateValues.yBottom && viewDetails && current
                ? {
                    transform: `translateY(${
                      scaledPillarTranslateValues.yBottom
                    }px) translateX(${
                      color === 'green'
                        ? `${scaledPillarTranslateValues.xLeft}px`
                        : `${scaledPillarTranslateValues.xRight}px`
                    })`,
                    opacity: 1,
                  }
                : {}
            }
            sideStylingLeft={pillarSide('bottomLeft', color)}
            sideStylingRight={pillarSide('bottomRight', color)}
            ref={bottomPillarRef}
          /> */}
        </>
      )}
      {/* <div
        style={
          animateReveal
            ? {
                transform: `translateY(-101%)`,
              }
            : {}
        }
        css={[
          reveal,
          {
            height: `${totalPercent}%`,
            display: revealAnimationDone ? 'none' : 'block',
          },
        ]}
      /> */}
    </div>
  );
};

Pillar.propTypes = {
  color: PropTypes.string,
  pillarPosition: PropTypes.string,
  totalPercent: PropTypes.number,
  shownPercent: PropTypes.number,
  // currentSwiperTranslate: PropTypes.number,
  // bottomPercent: PropTypes.number,
  // topPercent: PropTypes.number,
  // setRefs: PropTypes.func,
  hasScaledPillar: PropTypes.bool,
  isVisible: PropTypes.bool,
  backgroundPillar: PropTypes.bool,
  scaleSizeX: PropTypes.number,
  scaleSizeY: PropTypes.number,
  // detailScaledPosition: PropTypes.object,
  style: PropTypes.object,
  current: PropTypes.bool,
  pillarHeightInPixel: PropTypes.number,
  origWidthOfPillar: PropTypes.number,
  scaledWidthPixelSize: PropTypes.number,
  blurValue: PropTypes.number,
  showPillarGradient: PropTypes.bool,
  // sceneRef: PropTypes.oneOfType([
  //   // Either a function
  //   PropTypes.func,
  //   // Or the instance of a DOM native element (see the note about SSR)
  //   PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  // ]),
  // topLeftRef: PropTypes.oneOfType([
  //   // Either a function
  //   PropTypes.func,
  //   // Or the instance of a DOM native element (see the note about SSR)
  //   PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  // ]),
  // bottomLeftRef: PropTypes.oneOfType([
  //   // Either a function
  //   PropTypes.func,
  //   // Or the instance of a DOM native element (see the note about SSR)
  //   PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  // ]),
};

export default Pillar;
